import './Home.css'
// import Avatar from '../../assets/img/avatar.svg'
import About from '../About/About';
import Contact from '../Contact/Contact';
import Project from '../Projects/Project';


const Home = () => {
  return (
    <>
      <div className="section" id="home">
        <div className="home-content">
        <h1 className='main-textt'>Hey there</h1>
          <h2 className="main-text">I'm Ahmed Sameh</h2>
          <p className="secondary-text">Frontend Developer</p>
        </div>
      </div>
      <About />
      <Project/>
      <Contact/>
    </>
  );
}

export default Home